import {Header} from "../component/Header";
import Sticky from "react-stickynode";
import {AppHeader} from "../component/AppHeader";
import {AppFooter} from "../component/AppFooter";
import {AppCopyright} from "../component/AppCopyright";
import {withRouter} from "react-router-dom";
import React from "react";
import {BankFailureMessage} from "../component/BankFailureMessage";

function Container({history}) {
    return <><Header/>
        <Sticky innerZ={1}>
            <AppHeader/>
        </Sticky>

        <div className="clearfix"></div>
        <BankFailureMessage history={history}/>
        <AppFooter/>
        <AppCopyright/>

        <div className="clearfix"></div>
    </>
}

export const BankFailureContainer = withRouter(({history}) => <Container history={history}/>);